// Images for left-to-right trail (1.png to 11.png)
export const leftToRightImages = [
  { src: '/1.png', alt: 'Diwali Image 1' },
  { src: '/2.png', alt: 'Diwali Image 2' },
  { src: '/3.png', alt: 'Diwali Image 3' },
  { src: '/4.png', alt: 'Diwali Image 4' },
  { src: '/5.png', alt: 'Diwali Image 5' },
  { src: '/6.png', alt: 'Diwali Image 6' },
  { src: '/7.png', alt: 'Diwali Image 7' },
  { src: '/8.png', alt: 'Diwali Image 8' },
  { src: '/9.png', alt: 'Diwali Image 9' },
  { src: '/10.png', alt: 'Diwali Image 10' },
  { src: '/11.png', alt: 'Diwali Image 11' }
];

// Images for right-to-left trail (12.png to 21.png)
export const rightToLeftImages = [
  { src: '/12.png', alt: 'Diwali Image 12' },
  { src: '/13.png', alt: 'Diwali Image 13' },
  { src: '/14.png', alt: 'Diwali Image 14' },
  { src: '/15.png', alt: 'Diwali Image 15' },
  { src: '/16.png', alt: 'Diwali Image 16' },
  { src: '/17.png', alt: 'Diwali Image 17' },
  { src: '/18.png', alt: 'Diwali Image 18' },
  { src: '/19.png', alt: 'Diwali Image 19' },
  { src: '/20.png', alt: 'Diwali Image 20' },
  { src: '/21.png', alt: 'Diwali Image 21' }
];
